import config from './../config/config.provider';

const env = (config.env !== "production") ? `.${config.env}` : '';

export const getLogo = ({ gb_cause_id, subentity_id = 0 }) => {
  return `//cdn${env}.startupmedia.com/greenback/entities/${gb_cause_id}/${subentity_id}/logo`;
};
